export const dev = {
    api: "http://localhost:5005/deknerd-556e6/us-central1",
    apiNerdof: "http://localhost:80/api",
    serverName: "TEST",
    secretKey: "kJYSb2aTHqa3JBGV",
    frontend: "http://localhost:8081"
}

export const prod = {
    api: "https://us-central1-deknerd-556e6.cloudfunctions.net",
    apiNerdof: "https://api.nerdof.com/api",
    serverName: "TULA",
    secretKey: "kJYSb2aTHqa3JBGV",
    frontend: "https://nerdof.com"
}